import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab)

const FaIcon = (props) => {
  const { icon, ...iconProps } = props
  let prefix = icon.includes('-o') ? 'far' : 'fas'
  let iconName = icon.includes('-o') ? icon.split('-o')[0] : icon
  const finalIconName = findIconDefinition({ prefix: prefix, iconName: iconName })

  return (
    <FontAwesomeIcon icon={finalIconName} { ...iconProps } />
  )
}


FaIcon.propTypes = {
  // Name of the icon
  icon: PropTypes.string.isRequired,
}

FaIcon.defaultProps = {
  icon: null,
}

export default FaIcon
